import React from "react";
import Select from "./Select";
import memoize from "memoize-weak";

const getProductOptions = memoize((products) => [
  [-1, I18n.t("papp.components.ProductsSelectControl.blank_label")],
  ...products
    .map((p) => {
      if (p.name === null) p.name = "";

      return [p.id, p.name];
    })
    .sort((a, b) => a[1].localeCompare(b[1])),
]);

const ProductsSelect = ({ products, ...props }) => (
  <Select options={getProductOptions(products)} includeBlank search {...props} />
);

export default ProductsSelect;



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/ProductsSelect.jsx